/** Shown wherever a value is missing or unparseable. */
export const EMPTY_DATE = "-";

const LOCALE = "de-DE";
/** Admin data is read by a German ops team; pinning the zone keeps a row's
 * rendered day identical no matter where the browser runs. */
const TIME_ZONE = "Europe/Berlin";

export type DateInput = Date | string | number | null | undefined;

const dateFormatter = new Intl.DateTimeFormat(LOCALE, {
	day: "2-digit",
	month: "2-digit",
	timeZone: TIME_ZONE,
	year: "numeric",
});

const dateTimeFormatter = new Intl.DateTimeFormat(LOCALE, {
	day: "2-digit",
	hour: "2-digit",
	hour12: false,
	minute: "2-digit",
	month: "2-digit",
	timeZone: TIME_ZONE,
	year: "numeric",
});

function toDate(value: DateInput): Date | undefined {
	if (value === null || value === undefined) return undefined;
	const date = value instanceof Date ? value : new Date(value);
	return Number.isNaN(date.getTime()) ? undefined : date;
}

/** German short date, e.g. `25.08.2026`. */
export function formatDate(value: DateInput): string {
	const date = toDate(value);
	return date ? dateFormatter.format(date) : EMPTY_DATE;
}

/** German short date with a 24-hour time, e.g. `25.08.2026, 14:30`. */
export function formatDateTime(value: DateInput): string {
	const date = toDate(value);
	return date ? dateTimeFormatter.format(date) : EMPTY_DATE;
}

const timeFormatter = new Intl.DateTimeFormat(LOCALE, {
	hour: "2-digit",
	hour12: false,
	minute: "2-digit",
	timeZone: TIME_ZONE,
});

/** 24-hour Berlin time, e.g. `14:30`. */
export function formatTime(value: DateInput): string {
	const date = toDate(value);
	return date ? timeFormatter.format(date) : EMPTY_DATE;
}
